import { createSlice } from '@reduxjs/toolkit';

import { DRUG_NAMES_KEY } from 'utilities/storageKeys';

import { get } from 'temp/utilities/storage';

export const prescriptionDetails = createSlice({
    name: 'prescriptionDetails',

    initialState: {
        drugNames: get(DRUG_NAMES_KEY, []),
        isApiFailed: false
    },

    reducers: {
        setDrugNames: (state, action) => {
            state.drugNames = action.payload;
        },
        setIsApiFailed: (state, action) => {
            state.isApiFailed = action.payload;
        }
    }
});

export const { setDrugNames, setIsApiFailed } = prescriptionDetails.actions;

export default prescriptionDetails.reducer;
